/* ==========================================================================
   Elevate Floors — Seção 01: hero fixo + cabeçalho sticky
   --------------------------------------------------------------------------
   Três responsabilidades:
   1. pinHeader()  — em TODAS as páginas. Marca .is-pinned no .section-header
                     no instante em que ele gruda no topo, para o raio ir a 0.
   2. hideHero()   — só na home. Esconde o hero depois de coberto pela folha.
   3. initSlider() — só na home e só com 2+ slides.

   Tudo é re-executável: o editor de tema troca nós do DOM a cada save e
   dispara shopify:section:load.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- 1. o cabeçalho grudou? --------------------------------------
     Sem elemento sentinela: o .section-header tem top:-1px, então com
     threshold:[1] ele deixa de estar 100% visível exatamente no frame em que
     gruda no topo. Aí o raio dos cantos superiores vai a 0. ------------------ */
  function pinHeader() {
    var header = document.querySelector('.section-header');
    if (!header || !('IntersectionObserver' in window)) return;

    if (header._efPinObserver) header._efPinObserver.disconnect();

    header._efPinObserver = new IntersectionObserver(
      function (entries) {
        header.classList.toggle('is-pinned', entries[0].intersectionRatio < 1);
      },
      { threshold: [1] }
    );
    header._efPinObserver.observe(header);
  }

  /* ---------- 2. esconder o hero depois de coberto -------------------------
     O rootMargin de 35% reproduz o limiar de 1.35x do handoff sem precisar de
     um scroll listener disparando a cada frame. ---------------------------- */
  function hideHero() {
    var hero = document.getElementById('ef-hero');
    var spacer = document.querySelector('.ef-hero-spacer');
    if (!hero || !spacer || !('IntersectionObserver' in window)) return;

    if (hero._efHideObserver) hero._efHideObserver.disconnect();

    hero._efHideObserver = new IntersectionObserver(
      function (entries) {
        var covered = !entries[0].isIntersecting;
        hero.style.opacity = covered ? '0' : '1';
        hero.style.visibility = covered ? 'hidden' : 'visible';
      },
      { threshold: 0, rootMargin: '35% 0px 0px 0px' }
    );
    hero._efHideObserver.observe(spacer);
  }

  /* ---------- 3. slider ---------------------------------------------------- */
  function forceMute(hero) {
    // O atributo muted no HTML não basta: alguns temas reativam o som ao
    // reidratar, e sem mute o navegador recusa o autoplay silenciosamente.
    Array.prototype.forEach.call(hero.querySelectorAll('video'), function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.volume = 0;
      // vídeo esperando a vez (slide inativo antes do load) não recebe play:
      // o play força o download e anularia o adiamento
      if (v.paused && !v._efPendente) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }

  function initSlider() {
    var hero = document.getElementById('ef-hero');
    if (!hero) return;

    if (hero._efStop) hero._efStop();

    forceMute(hero);

    var slides = Array.prototype.slice.call(hero.querySelectorAll('.ef-hero__slide'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('.ef-hero__dot'));
    if (slides.length < 2) return;

    var i = 0;
    var timer = null;
    var auto = hero.dataset.autoplay === 'true' && !reduce.matches;
    var ms = (parseInt(hero.dataset.interval, 10) || 4) * 1000;

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      // o slide chegou antes de a página terminar: carrega o vídeo dele agora
      if (slides[i]) carregaPendentes(slides[i]);
      forceMute(hero);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (auto) timer = setInterval(function () { go(i + 1); }, ms);
    }

    hero.querySelectorAll('.ef-hero__arrow').forEach(function (b) {
      b.addEventListener('click', function () {
        go(i + parseInt(b.dataset.dir, 10));
        start();
      });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.dataset.go, 10));
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    /* swipe no mobile */
    var x0 = null;
    hero.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
      stop();
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1));
      x0 = null;
      start();
    }, { passive: true });

    /* pausa quando a aba perde o foco */
    function onVisibility() { document.hidden ? stop() : start(); }
    document.addEventListener('visibilitychange', onVisibility);

    hero._efStop = function () {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };

    start();
  }

  /* ---------- 4. vídeo por largura de tela ---------------------------------
     <video> ignora <source media="...">: o atributo está na spec mas nenhum
     navegador o implementa, então a escolha entre o arquivo de desktop e o
     vertical é feita aqui. Só age quando o bloco tem vídeo mobile; sem ele o
     markup já nasce correto e esta função não toca em nada.

     O <video> vem com preload="none" nesse caso, para o arquivo de desktop não
     ser baixado num celular antes de a decisão acontecer. ---------------- */
  function carregaVideo(v) {
    v._efPendente = false;
    v.load();
    // autoplay pode ser recusado (bateria, economia de dados). O catch
    // existe para isso não virar erro no console.
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function carregaPendentes(escopo) {
    (escopo || document).querySelectorAll('[data-hero-video]').forEach(function (v) {
      if (v._efPendente) carregaVideo(v);
    });
  }
  window.addEventListener('load', function () { carregaPendentes(); });

  function heroVideo() {
    var mq = window.matchMedia('(max-width: 900px)');

    document.querySelectorAll('[data-hero-video]').forEach(function (v) {
      var mobileSrc = v.getAttribute('data-video-mobile');
      if (!mobileSrc || v._efVideoBound) return;
      v._efVideoBound = true;

      var source = v.querySelector('source');
      if (!source) return;

      var deskSrc = source.getAttribute('src');
      var deskPoster = v.getAttribute('poster') || '';
      var mobPoster = v.getAttribute('data-poster-mobile') || deskPoster;

      function apply() {
        var small = mq.matches;
        var want = small ? mobileSrc : deskSrc;
        if (v._efCurrentSrc === want) return;      // nada mudou, não recarrega
        v._efCurrentSrc = want;

        source.setAttribute('src', want);
        if (deskPoster) v.setAttribute('poster', small ? mobPoster : deskPoster);

        /* Vídeo de um slide que ainda não está na tela não carrega agora: ele
           baixava junto com a abertura da home e roubava banda do formulário e
           das imagens de cima. Fica marcado e carrega quando o slide chega
           (go()) ou quando a página termina de carregar, o que vier antes —
           assim, na vez dele, normalmente já está pronto. */
        var slide = v.closest('.ef-hero__slide');
        if (slide && !slide.classList.contains('is-active') && document.readyState !== 'complete') {
          v._efPendente = true;
          return;
        }
        carregaVideo(v);
      }

      apply();
      if (mq.addEventListener) mq.addEventListener('change', apply);
    });
  }

  function init() {
    pinHeader();
    hideHero();
    heroVideo();
    initSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // O editor de tema substitui o DOM da seção a cada save: sem isto o
  // observer fica preso a um nó detached e o pin para de funcionar.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
